/* Trusted-roles portal (RO1, RO2, Security Officer, Operator, Auditor) and
   the super-admin "Trusted Roles" settings page. */
export const trustedTranslation = {
  en: {
    trustedPortalShort: "Trusted Roles",
    trustedNotifications: "Notifications",
    trustedAuditLog: "Audit log",
    trustedLatestTasks: "Latest tasks",
    trustedViewAll: "View all",
    trustedNoTasks: "No tasks yet. New work for your role appears here.",
    trustedOnlyUnread: "Only unread",
    trustedMarkAllRead: "Mark all as read",
    trustedAuditAt: "Date",
    trustedAuditAction: "Action",
    trustedAuditActor: "By",
    trustedAuditTarget: "Target",
    trustedAuditStatus: "Result",
    trustedAuditAllActions: "All actions",
    trustedAuditFrom: "From",
    trustedAuditTo: "To",
    trustedChangePasswordTitle: "Choose your password",
    trustedChangePasswordHint: "You signed in with a temporary password from the super admin. Choose your own password to continue.",
    trustedOfficers: "Officers",
    trustedRolesColumn: "Roles",
    trustedOfficerAdd: "Add officer",
    trustedOfficerAddHint: "Create the officer account, then share the National ID and the temporary password with the officer. They sign in only to the trusted-roles portal and must choose their own password at the first sign-in.",
    trustedOfficerCreate: "Create officer",
    trustedOfficerEdit: "Edit",
    trustedOfficerResetPassword: "Reset password",
    trustedOfficerResetHint: "Set a new temporary password and share it with the officer. Their open sessions end and they must choose a new password at the next sign-in.",
    trustedOfficerTempPassword: "Temporary password",
    trustedOfficerActivate: "Activate",
    trustedOfficerDeactivate: "Deactivate",
    trustedOfficerActivateHint: "The officer can sign in to the trusted-roles portal again.",
    trustedOfficerDeactivateHint: "The officer can no longer sign in and their open sessions end now. Roles are kept.",
    trustedOfficerActive: "Active",
    trustedOfficerInactive: "Inactive",
    trustedOfficerMustChange: "Must change password",
    trustedOfficerLegacy: "Workflow account",
    trustedOfficerLastLogin: "Last sign-in",
    trustedOfficerNever: "Never",
    trustedOfficerAddRole: "Add role",
    trustedOfficerRoleRequired: "Choose at least one role",
    trustedOfficerPhoneHint: "The sign-in code is sent by SMS to this number (05xxxxxxxx).",
    trustedOfficerPhoneHintEdit: "Current: {{phone}}. Leave empty to keep it.",
    trustedOfficerHowTitle: "How officer access works",
    trustedOfficerHow1: "Add the officer with their National ID, email, mobile, a temporary password and their role(s).",
    trustedOfficerHow2: "Share the National ID and temporary password with the officer. They sign in at",
    trustedOfficerHow3: "They confirm with an SMS code and choose their own password. Officer accounts cannot use the workflow app.",
    trustedEmailInvalid: "Enter a valid email",
    trustedPhoneInvalid: "Enter a Saudi mobile number (05xxxxxxxx)",
    trustedPortal: "Trusted Roles Portal",
    trustedPortalHint: "Certificate officers only. Sign in with your National ID and password; we will send a code to your mobile.",
    trustedPassword: "Password",
    trustedPasswordPlaceholder: "Your password",
    trustedPasswordRequired: "Enter your password",
    trustedSendCodeBy: "Send the verification code by",
    trustedChannelSms: "SMS",
    trustedChannelEmail: "Email",
    trustedContinue: "Continue",
    trustedOtpCode: "Verification code",
    trustedOtpSentTo: "We sent a 6-digit code to",
    trustedOtpSentGeneric: "If the details are correct, a 6-digit code has been sent.",
    trustedResendCode: "Resend code",
    trustedResendIn: "Resend in {{seconds}} s",
    trustedForgotPassword: "Forgot password / first login?",
    trustedSetPasswordTitle: "Set a new password",
    trustedSetPasswordHint: "Enter your National ID. We will send a code to your verified mobile.",
    trustedSendCode: "Send code",
    trustedNewPassword: "New password",
    trustedConfirmPassword: "Confirm new password",
    trustedPasswordRules: "At least 12 characters with upper and lower case letters, a number and a symbol.",
    trustedPasswordWeak: "The password does not meet the rules below.",
    trustedPasswordMismatch: "The passwords do not match.",
    trustedSavePassword: "Save password",
    trustedPasswordSaved: "Password saved. Please sign in.",
    trustedBackToLogin: "Back to sign in",
    trustedNationalId: "National ID",
    trustedNationalIdPlaceholder: "10-digit National ID",
    trustedNationalIdInvalid: "Enter a 10-digit National ID",
    trustedContinueNafath: "Continue with Nafath",
    trustedNafathOpenApp: "Open the Nafath app and choose this number",
    trustedNafathWaiting: "Waiting for Nafath approval…",
    trustedSetupTotp: "Set up your authenticator app",
    trustedSetupTotpHint: "Scan this code with Google Authenticator, Microsoft Authenticator or a similar app. It is shown only once.",
    trustedManualKey: "Or enter this key manually",
    trustedTotpCode: "Authenticator code",
    trustedTotpPlaceholder: "6-digit code",
    trustedTotpInvalid: "Enter the 6-digit code",
    trustedVerify: "Verify and sign in",
    trustedStartOver: "Start over",
    trustedSuperAdminLogin: "Super admin login",
    trustedPortalLink: "Trusted roles login (RO1 / RO2)",
    trustedLoginFailed: "Sign-in failed. Please try again.",
    trustedSignOut: "Sign out",
    trustedSignedInAs: "Signed in as",

    // Roles
    role_ro1: "Registration Officer (RO1)",
    role_ro2: "CA Administrator (RO2)",
    role_security_officer: "Security Officer",
    role_system_operator: "System Operator",
    role_system_auditor: "System Auditor",

    // Menu
    trustedDashboard: "Dashboard",
    trustedApplicationsReview: "Applications to validate",
    trustedIssuance: "Certificate issuance",
    trustedRevocations: "Revocations",
    trustedTickets: "Complaints & reports",

    // Dashboard
    trustedWelcome: "Welcome",
    trustedYourRoles: "Your roles",
    trustedAwaitingReview: "Awaiting review",
    trustedOverdue: "Overdue (over 24 h)",
    trustedReadyToIssue: "Ready to issue",
    trustedFailedIssuance: "Failed or uncertain issuance",
    trustedRevocationsAwaitingReview: "Revocations to review",
    trustedCompromiseToReview: "Key-compromise reviews",
    trustedAwaitingConfirmation: "Awaiting reason confirmation",
    trustedRevocationsToExecute: "Revocations to execute",
    trustedRevocationsFailed: "Failed revocations",
    trustedOpenTickets: "Open complaints & reports",
    trustedOverdueTickets: "Overdue complaints & reports",
    trustedOpen: "Open",
    trustedRefresh: "Refresh",

    // Applications
    trustedApplicant: "Applicant",
    trustedNationalIdMasked: "National ID",
    trustedCertificateType: "Certificate type",
    trustedFunding: "Funding",
    trustedStatus: "Status",
    trustedSubmittedAt: "Submitted",
    trustedSlaDue: "Due by",
    trustedDecidedAt: "Decided",
    trustedIssuedAt: "Issued",
    trustedActions: "Actions",
    trustedView: "View",
    trustedFilterStatus: "Status",
    trustedOnlyOverdue: "Only overdue",
    trustedReady: "Ready to issue",
    trustedFailed: "Failed / uncertain",
    trustedApplication: "Application",
    trustedIdentity: "Identity (from Nafath)",
    trustedConsents: "Consents accepted",
    trustedAuthority: "Organisation authority",
    trustedPayment: "Payment reference",
    trustedReplaces: "Replaces application",
    trustedDecision: "Decision",
    trustedDecisionBy: "Decided by",
    trustedReason: "Reason",
    trustedNotes: "Notes",
    trustedIssuedBy: "Issued by",
    trustedFailureReason: "Failure reason",
    trustedAge: "Age",
    trustedApprove: "Approve",
    trustedReject: "Reject",
    trustedApproveTitle: "Approve this application",
    trustedRejectTitle: "Reject this application",
    trustedReasonRequired: "A reason of at least 3 characters is required",
    trustedIssue: "Issue certificate",
    trustedRetry: "Retry issuance",
    trustedIssueConfirm: "Issue the certificate now? This calls DSG and cannot be undone.",
    trustedRetryConfirm: "Retry the DSG issuance for this application?",
    trustedApproverNotIssuer: "The officer who approved an application cannot issue it.",
    trustedBack: "Back",
    trustedCancel: "Cancel",
    trustedConfirm: "Confirm",
    trustedSave: "Save",
    trustedNone: "—",
    trustedYes: "Yes",
    trustedNo: "No",

    status_submitted: "Awaiting review",
    status_approved: "Approved",
    status_rejected: "Rejected",
    status_issuing: "Issuing (uncertain)",
    status_issued: "Issued",
    status_failed: "Failed",
    status_cancelled: "Cancelled",
    status_all: "All",
    status_pending_review: "Pending review",
    status_executing: "Executing",
    status_executed: "Executed",
    status_received: "Received",
    status_acknowledged: "Acknowledged",
    status_decided: "Decided",

    // Revocations
    trustedNewRevocation: "Record HAAT / authority revocation",
    trustedSerialNumber: "Certificate serial number",
    trustedRequesterType: "Requested by",
    requester_haat_global: "HAAT",
    requester_competent_authority: "Competent authority (DGA / NIC / SDAIA)",
    requester_problem_report: "Problem report",
    requester_subscriber: "Subscriber",
    requester_org_representative: "Organisation representative",
    requester_eseal_custodian: "E-Seal custodian",
    trustedExternalReference: "External reference",
    trustedRevocationReason: "Revocation reason",
    trustedNote: "Note",
    trustedNoteRequired: "A note of at least 3 characters is required",
    trustedImmediate: "Immediate",
    trustedCertificate: "Certificate",
    trustedSubject: "Subject",
    trustedRequestedAt: "Requested",
    trustedReviewTrail: "Review trail",
    trustedAttempts: "Attempts",
    trustedReview: "Review",
    trustedCompromiseReview: "Record compromise review",
    trustedConfirmReason: "Confirm reason",
    trustedExecute: "Execute revocation",
    trustedExecuteConfirm: "Revoke this certificate at DSG now? This cannot be undone.",
    trustedQueueEmpty: "Nothing in this queue.",
    queue_awaiting_review: "Awaiting RO1 review",
    queue_compromise_to_review: "Key-compromise post-reviews",
    queue_awaiting_confirmation: "Awaiting Security Officer confirmation",
    queue_to_execute: "Approved — ready to execute",
    queue_failed: "Failed — retry",
    reason_keyCompromise: "Key compromise",
    reason_affiliationChanged: "Affiliation changed",
    reason_superseded: "Superseded",
    reason_cessationOfOperation: "Cessation of operation",
    reason_privilegeWithdrawn: "Privilege withdrawn",

    // Tickets
    trustedReference: "Reference",
    trustedType: "Type",
    trustedSubjectLine: "Subject",
    trustedReceivedAt: "Received",
    trustedAckDue: "Acknowledge by",
    trustedDecisionDue: "Decide by",
    trustedContact: "Contact",
    trustedDescription: "Description",
    trustedOutcome: "Outcome",
    trustedEvents: "History",
    trustedAcknowledge: "Acknowledge",
    trustedDecide: "Record decision",
    trustedRevokeCertificate: "Revoke certificate",
    trustedDecisionText: "Decision (sent to the requester)",
    trustedDecisionRequired: "The decision must be at least 10 characters",
    trustedAllTypes: "All types",
    trustedAllStatuses: "All statuses",
    trustedCertificateMatched: "Matched to a certificate",
    ticket_problem_report: "Problem report",
    ticket_complaint: "Complaint",
    ticket_refund_request: "Refund request",
    outcome_upheld: "Upheld",
    outcome_partly_upheld: "Partly upheld",
    outcome_not_upheld: "Not upheld",
    outcome_resolved: "Resolved",
    outcome_revoked: "Certificate revoked",
    outcome_no_action: "No action",

    trustedActionDone: "Done",
    trustedFullName: "Full name",
    trustedNameEn: "Name (English)",
    trustedNameAr: "Name (Arabic)",
    trustedDob: "Date of birth",
    trustedNationality: "Nationality",
    trustedEmail: "Email",
    trustedPhone: "Mobile",
    trustedVerified: "verified",
    trustedNotVerified: "not verified",
    trustedNafathVerifiedAt: "Nafath verified at",
    trustedNafathRef: "Nafath transaction",
    trustedConsentType: "Document",
    trustedConsentVersion: "Version",
    trustedConsentAcceptedAt: "Accepted",
    trustedCompany: "Company",
    trustedUnifiedNumber: "Unified number (700)",
    trustedCrNumber: "CR number",
    trustedCrStatus: "CR status",
    trustedAuthorityBasis: "Authority basis",
    trustedLoadFailed: "Could not load the data.",

    // Super admin: Trusted Roles settings page
    trustedRolesSettings: "Trusted Roles",
    trustedRolesSettingsDesc: "Create RO1, RO2 and other certificate officer accounts",
    "Trusted Roles Icon": "Trusted Roles Icon",
    trustedRolesHolders: "Role holders",
    trustedRolesAssign: "Assign a role",
    trustedRolesAssignHint: "The person must already have a Nafath-verified HaatSign account. They sign in at /trusted/login.",
    trustedRolesRole: "Role",
    trustedRolesAssignBtn: "Assign",
    trustedRolesRemoveConfirm: "Remove this role? The officer's trusted sessions end immediately.",
    trustedRolesConflicts: "Roles one person may not hold together (CP/CPS §5.2.4)",
    trustedRolesAnyRole: "any other role",
    role_super_admin: "Super admin",
    trustedRolesNoHolders: "No officers yet. Use Add officer to create the first one.",
  },
  ar: {
    trustedPortalShort: "الأدوار الموثوقة",
    trustedNotifications: "الإشعارات",
    trustedAuditLog: "سجل التدقيق",
    trustedLatestTasks: "أحدث المهام",
    trustedViewAll: "عرض الكل",
    trustedNoTasks: "لا توجد مهام بعد. تظهر هنا الأعمال الجديدة الخاصة بدورك.",
    trustedOnlyUnread: "غير المقروءة فقط",
    trustedMarkAllRead: "تعليم الكل كمقروء",
    trustedAuditAt: "التاريخ",
    trustedAuditAction: "الإجراء",
    trustedAuditActor: "بواسطة",
    trustedAuditTarget: "الهدف",
    trustedAuditStatus: "النتيجة",
    trustedAuditAllActions: "كل الإجراءات",
    trustedAuditFrom: "من",
    trustedAuditTo: "إلى",
    trustedChangePasswordTitle: "اختر كلمة المرور",
    trustedChangePasswordHint: "سجّلت الدخول بكلمة مرور مؤقتة من المشرف العام. اختر كلمة مرور خاصة بك للمتابعة.",
    trustedOfficers: "الموظفون",
    trustedRolesColumn: "الأدوار",
    trustedOfficerAdd: "إضافة موظف",
    trustedOfficerAddHint: "أنشئ حساب الموظف ثم شارك رقم الهوية وكلمة المرور المؤقتة معه. يدخل فقط إلى بوابة الأدوار الموثوقة ويجب أن يختار كلمة مرور خاصة به عند أول دخول.",
    trustedOfficerCreate: "إنشاء الموظف",
    trustedOfficerEdit: "تعديل",
    trustedOfficerResetPassword: "إعادة تعيين كلمة المرور",
    trustedOfficerResetHint: "عيّن كلمة مرور مؤقتة جديدة وشاركها مع الموظف. تنتهي جلساته المفتوحة ويجب أن يختار كلمة مرور جديدة عند الدخول التالي.",
    trustedOfficerTempPassword: "كلمة المرور المؤقتة",
    trustedOfficerActivate: "تفعيل",
    trustedOfficerDeactivate: "إيقاف",
    trustedOfficerActivateHint: "يمكن للموظف الدخول إلى بوابة الأدوار الموثوقة مرة أخرى.",
    trustedOfficerDeactivateHint: "لن يتمكن الموظف من الدخول وتنتهي جلساته المفتوحة الآن. تبقى الأدوار محفوظة.",
    trustedOfficerActive: "نشط",
    trustedOfficerInactive: "موقوف",
    trustedOfficerMustChange: "يجب تغيير كلمة المرور",
    trustedOfficerLegacy: "حساب سير العمل",
    trustedOfficerLastLogin: "آخر دخول",
    trustedOfficerNever: "لم يسجّل الدخول",
    trustedOfficerAddRole: "إضافة دور",
    trustedOfficerRoleRequired: "اختر دورًا واحدًا على الأقل",
    trustedOfficerPhoneHint: "يُرسل رمز الدخول برسالة نصية إلى هذا الرقم (05xxxxxxxx).",
    trustedOfficerPhoneHintEdit: "الحالي: {{phone}}. اتركه فارغًا للإبقاء عليه.",
    trustedOfficerHowTitle: "كيف يعمل دخول الموظفين",
    trustedOfficerHow1: "أضف الموظف برقم الهوية والبريد والجوال وكلمة مرور مؤقتة والأدوار.",
    trustedOfficerHow2: "شارك رقم الهوية وكلمة المرور المؤقتة مع الموظف. يسجّل الدخول من",
    trustedOfficerHow3: "يؤكد برمز رسالة نصية ويختار كلمة مرور خاصة به. لا يمكن لحسابات الموظفين استخدام تطبيق سير العمل.",
    trustedEmailInvalid: "أدخل بريدًا إلكترونيًا صحيحًا",
    trustedPhoneInvalid: "أدخل رقم جوال سعودي (05xxxxxxxx)",
    trustedPortal: "بوابة الأدوار الموثوقة",
    trustedPortalHint: "لموظفي الشهادات فقط. سجّل الدخول برقم الهوية وكلمة المرور، وسنرسل رمزًا إلى جوالك.",
    trustedPassword: "كلمة المرور",
    trustedPasswordPlaceholder: "كلمة المرور",
    trustedPasswordRequired: "أدخل كلمة المرور",
    trustedSendCodeBy: "إرسال رمز التحقق عبر",
    trustedChannelSms: "رسالة نصية",
    trustedChannelEmail: "البريد الإلكتروني",
    trustedContinue: "متابعة",
    trustedOtpCode: "رمز التحقق",
    trustedOtpSentTo: "أرسلنا رمزًا من 6 أرقام إلى",
    trustedOtpSentGeneric: "إذا كانت البيانات صحيحة فقد أُرسل رمز من 6 أرقام.",
    trustedResendCode: "إعادة إرسال الرمز",
    trustedResendIn: "إعادة الإرسال بعد {{seconds}} ث",
    trustedForgotPassword: "نسيت كلمة المرور / أول دخول؟",
    trustedSetPasswordTitle: "تعيين كلمة مرور جديدة",
    trustedSetPasswordHint: "أدخل رقم الهوية وسنرسل رمزًا إلى جوالك الموثّق.",
    trustedSendCode: "إرسال الرمز",
    trustedNewPassword: "كلمة المرور الجديدة",
    trustedConfirmPassword: "تأكيد كلمة المرور الجديدة",
    trustedPasswordRules: "12 حرفًا على الأقل تتضمن حروفًا كبيرة وصغيرة ورقمًا ورمزًا.",
    trustedPasswordWeak: "كلمة المرور لا تستوفي الشروط أدناه.",
    trustedPasswordMismatch: "كلمتا المرور غير متطابقتين.",
    trustedSavePassword: "حفظ كلمة المرور",
    trustedPasswordSaved: "تم حفظ كلمة المرور. يرجى تسجيل الدخول.",
    trustedBackToLogin: "العودة لتسجيل الدخول",
    trustedNationalId: "رقم الهوية الوطنية",
    trustedNationalIdPlaceholder: "رقم الهوية (10 أرقام)",
    trustedNationalIdInvalid: "أدخل رقم هوية من 10 أرقام",
    trustedContinueNafath: "المتابعة عبر نفاذ",
    trustedNafathOpenApp: "افتح تطبيق نفاذ واختر هذا الرقم",
    trustedNafathWaiting: "بانتظار الموافقة في نفاذ…",
    trustedSetupTotp: "إعداد تطبيق المصادقة",
    trustedSetupTotpHint: "امسح هذا الرمز بتطبيق Google Authenticator أو Microsoft Authenticator أو ما يشابهه. يظهر مرة واحدة فقط.",
    trustedManualKey: "أو أدخل هذا المفتاح يدويًا",
    trustedTotpCode: "رمز تطبيق المصادقة",
    trustedTotpPlaceholder: "رمز من 6 أرقام",
    trustedTotpInvalid: "أدخل الرمز المكوّن من 6 أرقام",
    trustedVerify: "تحقق وسجّل الدخول",
    trustedStartOver: "البدء من جديد",
    trustedSuperAdminLogin: "دخول المشرف العام",
    trustedPortalLink: "دخول الأدوار الموثوقة (RO1 / RO2)",
    trustedLoginFailed: "تعذّر تسجيل الدخول. حاول مرة أخرى.",
    trustedSignOut: "تسجيل الخروج",
    trustedSignedInAs: "مسجّل الدخول باسم",

    role_ro1: "موظف التسجيل (RO1)",
    role_ro2: "مسؤول جهة التصديق (RO2)",
    role_security_officer: "مسؤول الأمن",
    role_system_operator: "مشغّل النظام",
    role_system_auditor: "مدقق النظام",

    trustedDashboard: "لوحة التحكم",
    trustedApplicationsReview: "طلبات بانتظار التحقق",
    trustedIssuance: "إصدار الشهادات",
    trustedRevocations: "الإلغاءات",
    trustedTickets: "الشكاوى والبلاغات",

    trustedWelcome: "مرحبًا",
    trustedYourRoles: "أدوارك",
    trustedAwaitingReview: "بانتظار المراجعة",
    trustedOverdue: "متأخرة (أكثر من 24 ساعة)",
    trustedReadyToIssue: "جاهزة للإصدار",
    trustedFailedIssuance: "إصدار فاشل أو غير مؤكد",
    trustedRevocationsAwaitingReview: "إلغاءات بانتظار المراجعة",
    trustedCompromiseToReview: "مراجعات اختراق المفتاح",
    trustedAwaitingConfirmation: "بانتظار تأكيد السبب",
    trustedRevocationsToExecute: "إلغاءات جاهزة للتنفيذ",
    trustedRevocationsFailed: "إلغاءات فاشلة",
    trustedOpenTickets: "شكاوى وبلاغات مفتوحة",
    trustedOverdueTickets: "شكاوى وبلاغات متأخرة",
    trustedOpen: "فتح",
    trustedRefresh: "تحديث",

    trustedApplicant: "مقدّم الطلب",
    trustedNationalIdMasked: "رقم الهوية",
    trustedCertificateType: "نوع الشهادة",
    trustedFunding: "التمويل",
    trustedStatus: "الحالة",
    trustedSubmittedAt: "تاريخ التقديم",
    trustedSlaDue: "الموعد النهائي",
    trustedDecidedAt: "تاريخ القرار",
    trustedIssuedAt: "تاريخ الإصدار",
    trustedActions: "الإجراءات",
    trustedView: "عرض",
    trustedFilterStatus: "الحالة",
    trustedOnlyOverdue: "المتأخرة فقط",
    trustedReady: "جاهزة للإصدار",
    trustedFailed: "فاشلة / غير مؤكدة",
    trustedApplication: "الطلب",
    trustedIdentity: "الهوية (من نفاذ)",
    trustedConsents: "الموافقات المقبولة",
    trustedAuthority: "تفويض المنشأة",
    trustedPayment: "مرجع الدفع",
    trustedReplaces: "يحل محل الطلب",
    trustedDecision: "القرار",
    trustedDecisionBy: "صاحب القرار",
    trustedReason: "السبب",
    trustedNotes: "ملاحظات",
    trustedIssuedBy: "أصدرها",
    trustedFailureReason: "سبب الفشل",
    trustedAge: "العمر",
    trustedApprove: "موافقة",
    trustedReject: "رفض",
    trustedApproveTitle: "الموافقة على هذا الطلب",
    trustedRejectTitle: "رفض هذا الطلب",
    trustedReasonRequired: "السبب مطلوب (3 أحرف على الأقل)",
    trustedIssue: "إصدار الشهادة",
    trustedRetry: "إعادة محاولة الإصدار",
    trustedIssueConfirm: "إصدار الشهادة الآن؟ سيتم الاتصال بـ DSG ولا يمكن التراجع.",
    trustedRetryConfirm: "إعادة محاولة الإصدار من DSG لهذا الطلب؟",
    trustedApproverNotIssuer: "لا يمكن لمن وافق على الطلب أن يصدره.",
    trustedBack: "رجوع",
    trustedCancel: "إلغاء",
    trustedConfirm: "تأكيد",
    trustedSave: "حفظ",
    trustedNone: "—",
    trustedYes: "نعم",
    trustedNo: "لا",

    status_submitted: "بانتظار المراجعة",
    status_approved: "موافق عليه",
    status_rejected: "مرفوض",
    status_issuing: "قيد الإصدار (غير مؤكد)",
    status_issued: "صادرة",
    status_failed: "فاشل",
    status_cancelled: "ملغى",
    status_all: "الكل",
    status_pending_review: "بانتظار المراجعة",
    status_executing: "قيد التنفيذ",
    status_executed: "منفّذ",
    status_received: "مستلم",
    status_acknowledged: "تم الإقرار",
    status_decided: "تم البت",

    trustedNewRevocation: "تسجيل إلغاء من هات / جهة مختصة",
    trustedSerialNumber: "الرقم التسلسلي للشهادة",
    trustedRequesterType: "مقدّم الطلب",
    requester_haat_global: "هات",
    requester_competent_authority: "جهة مختصة (DGA / NIC / SDAIA)",
    requester_problem_report: "بلاغ مشكلة",
    requester_subscriber: "المشترك",
    requester_org_representative: "ممثل المنشأة",
    requester_eseal_custodian: "أمين الختم الإلكتروني",
    trustedExternalReference: "المرجع الخارجي",
    trustedRevocationReason: "سبب الإلغاء",
    trustedNote: "ملاحظة",
    trustedNoteRequired: "الملاحظة مطلوبة (3 أحرف على الأقل)",
    trustedImmediate: "فوري",
    trustedCertificate: "الشهادة",
    trustedSubject: "صاحب الشهادة",
    trustedRequestedAt: "تاريخ الطلب",
    trustedReviewTrail: "مسار المراجعة",
    trustedAttempts: "المحاولات",
    trustedReview: "مراجعة",
    trustedCompromiseReview: "تسجيل مراجعة الاختراق",
    trustedConfirmReason: "تأكيد السبب",
    trustedExecute: "تنفيذ الإلغاء",
    trustedExecuteConfirm: "إلغاء هذه الشهادة لدى DSG الآن؟ لا يمكن التراجع.",
    trustedQueueEmpty: "لا يوجد شيء في هذه القائمة.",
    queue_awaiting_review: "بانتظار مراجعة RO1",
    queue_compromise_to_review: "مراجعات لاحقة لاختراق المفتاح",
    queue_awaiting_confirmation: "بانتظار تأكيد مسؤول الأمن",
    queue_to_execute: "موافق عليها — جاهزة للتنفيذ",
    queue_failed: "فاشلة — أعد المحاولة",
    reason_keyCompromise: "اختراق المفتاح",
    reason_affiliationChanged: "تغيّر الانتماء",
    reason_superseded: "استُبدلت",
    reason_cessationOfOperation: "توقف التشغيل",
    reason_privilegeWithdrawn: "سحب الصلاحية",

    trustedReference: "المرجع",
    trustedType: "النوع",
    trustedSubjectLine: "الموضوع",
    trustedReceivedAt: "تاريخ الاستلام",
    trustedAckDue: "الإقرار قبل",
    trustedDecisionDue: "البت قبل",
    trustedContact: "جهة التواصل",
    trustedDescription: "الوصف",
    trustedOutcome: "النتيجة",
    trustedEvents: "السجل",
    trustedAcknowledge: "إقرار الاستلام",
    trustedDecide: "تسجيل القرار",
    trustedRevokeCertificate: "إلغاء الشهادة",
    trustedDecisionText: "القرار (يُرسل لمقدّم الطلب)",
    trustedDecisionRequired: "القرار يجب أن يكون 10 أحرف على الأقل",
    trustedAllTypes: "كل الأنواع",
    trustedAllStatuses: "كل الحالات",
    trustedCertificateMatched: "مطابق لشهادة",
    ticket_problem_report: "بلاغ مشكلة",
    ticket_complaint: "شكوى",
    ticket_refund_request: "طلب استرداد",
    outcome_upheld: "مقبولة",
    outcome_partly_upheld: "مقبولة جزئيًا",
    outcome_not_upheld: "غير مقبولة",
    outcome_resolved: "تم الحل",
    outcome_revoked: "أُلغيت الشهادة",
    outcome_no_action: "لا إجراء",

    trustedActionDone: "تم",
    trustedFullName: "الاسم الكامل",
    trustedNameEn: "الاسم (إنجليزي)",
    trustedNameAr: "الاسم (عربي)",
    trustedDob: "تاريخ الميلاد",
    trustedNationality: "الجنسية",
    trustedEmail: "البريد الإلكتروني",
    trustedPhone: "الجوال",
    trustedVerified: "موثّق",
    trustedNotVerified: "غير موثّق",
    trustedNafathVerifiedAt: "تاريخ التحقق عبر نفاذ",
    trustedNafathRef: "معاملة نفاذ",
    trustedConsentType: "المستند",
    trustedConsentVersion: "الإصدار",
    trustedConsentAcceptedAt: "تاريخ القبول",
    trustedCompany: "المنشأة",
    trustedUnifiedNumber: "الرقم الموحد (700)",
    trustedCrNumber: "رقم السجل التجاري",
    trustedCrStatus: "حالة السجل التجاري",
    trustedAuthorityBasis: "أساس التفويض",
    trustedLoadFailed: "تعذّر تحميل البيانات.",

    trustedRolesSettings: "الأدوار الموثوقة",
    trustedRolesSettingsDesc: "إنشاء حسابات RO1 و RO2 وموظفي الشهادات الآخرين",
    "Trusted Roles Icon": "أيقونة الأدوار الموثوقة",
    trustedRolesHolders: "أصحاب الأدوار",
    trustedRolesAssign: "تعيين دور",
    trustedRolesAssignHint: "يجب أن يكون للشخص حساب في هات ساين موثّق عبر نفاذ. يسجّل الدخول من /trusted/login.",
    trustedRolesRole: "الدور",
    trustedRolesAssignBtn: "تعيين",
    trustedRolesRemoveConfirm: "إزالة هذا الدور؟ تنتهي جلسات الموظف الموثوقة فورًا.",
    trustedRolesConflicts: "أدوار لا يجوز أن يجمعها شخص واحد (CP/CPS §5.2.4)",
    trustedRolesAnyRole: "أي دور آخر",
    role_super_admin: "المشرف العام",
    trustedRolesNoHolders: "لا يوجد موظفون بعد. استخدم إضافة موظف لإنشاء أول حساب.",
  },
};
